export default __webpack_public_path__ + "assets/ico_feed_like_outlined-9c4bf451.svg";